import crypto from 'crypto'
import { func } from 'prop-types'

// 手机号码格式正则(严格)
export const phoneReg = /^(?:(?:\+|00)86)?1\d{10}$/
// 邮箱格式正则
export const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
// 社会信用代码格式正则
export const socialRreditReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
// 密码格式正则
export const passwordReg = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
// 座机格式正则
export const landlineReg = /0\d{2,3}-\d{7,8}$/
// qq号码格式正则
export const qqReg = /^[1-9][0-9]{4,10}$/
// 邮编格式正则
export const postcodeReg = /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/
// 网址格式正则
export const urlReg = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/

// 直接返回图片的文件
export const acceptImgList = ['jpg', 'png']

// 直接返回图片的文件
export function isAcceptImg(extName) {
  return extName && acceptImgList.indexOf(extName.toLocaleLowerCase()) !== -1
}

// 加密
export function hashField(field) {
  return crypto.createHash('sha1').update(String(field)).digest('hex')
}

export function exportStreamFiles(data, name) {
  const blob = new Blob([data.blob])
  const elink = document.createElement('a')
  document.body.appendChild(elink)
  elink.download = name
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  elink.click()
  document.body.removeChild(elink)
}

export function setSession(name, value) {
  sessionStorage.setItem(name, value)
}
export function getSession(name) {
  return sessionStorage.getItem(name)
}

export function qqValidator(_rule, value) {
  console.log(qqReg.test(value), value && !qqReg.test(value))
  if (value && !qqReg.test(value)) {
    console.log('reject')
    return Promise.reject(new Error())
  } else {
    console.log('resolve')
    return Promise.resolve()
  }
}

const entranceList = {
  dev: 'http://member-admin.ccia.dev.pazc.paic.com.cn/#/account/login',
  st: 'http://member-admin.ccia.st.pazc.paic.com.cn/#/account/login',
  zcpre: 'http://124.70.16.35:8081/#/account/login',
  ga: 'http://124.70.16.35:81/#/account/login',
  gaDomain: 'http://hygl.zgjzy.org.cn/#/account/login',
}

const _3AEntranceList = {
  dev: 'http://3a.ccia.dev.pazc.paic.com.cn',
  st: 'http://3a.ccia.st.pazc.paic.com.cn',
  zcpre: 'http://124.70.16.35:8082',
  ga: 'http://124.70.16.35:82',
  gaDomain: 'http://3a.zgjzy.org.cn',
}

function getEnv() {
  // eslint-disable-next-line no-restricted-globals
  let href = location.href
  if (href.indexOf('.zgjzy.org.cn') !== -1) {
    return 'gaDomain'
  } else if (href.indexOf('.dev.pazc.paic.com.cn') !== -1) {
    return 'dev'
  } else if (href.indexOf('.st.pazc.paic.com.cn') !== -1) {
    return 'st'
  } else if (href.indexOf('124.70.16.35:8080') !== -1) {
    return 'zcpre'
  } else {
    return 'ga'
  }
}

export function getEntrance() {
  // eslint-disable-next-line no-restricted-globals
  return entranceList[getEnv()]
}

export function get3AEntrance() {
  return _3AEntranceList[getEnv()]
}
